/**
 * @file
 * Attach behaviors for articles.
 */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Article behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.article = {
    // If this media query changes, it must also be changed
    // in article.scss!
    desktopMQ: window.matchMedia('(min-width: 55em)'),
    mobileMenuActive: false,
    containerClass: 'article__upper',
    attach: function (context) {
      const behavior = this;
      const $menus = $('.article__related-div', context);

      const respond = function (eventOrMediaQueryList) {
        $menus.each((i, el) => {
          const $menu = $(el);
          const $container = $menu.parents(`.${behavior.containerClass}`);

          // Desktop widths
          if (eventOrMediaQueryList.matches) {
            if (behavior.mobileMenuActive) {
              behavior.destroyMobileMenu($menu, $container);
            }

            return;
          }

          // Mobile widths
          behavior.createMobileMenu($menu, $container);
        });
      };

      respond(this.desktopMQ);
      this.desktopMQ.addListener(respond);
    },

    createMobileMenu: function ($menu, $container) {
      $container.css('--menu-height', `${$menu.find('ul').height()}px`);
      $container.css('--menu-height',
        `${$menu.find('.views-element-container').height()}px`);
      $container.addClass(`${this.containerClass}--js`);

      $menu.on('click.menuButtons', '.article__button--expand', () => {
        $container.addClass(`${this.containerClass}--expanded`);
      });

      $menu.on('click.menuButtons', '.article__button--collapse', () => {
        $container.removeClass(`${this.containerClass}--expanded`);
      });

      if (!$menu.data('menuButtons')) {
        $menu.data('menuButtons', $(`
          <span class="article__related-nav">
            <button class="article__button article__button--expand">
              Expand Menu
            </button>
            <button class="article__button article__button--collapse">
              Collapse Menu
            </button>
            </span>
        `));
      }

      $menu.data('menuButtons').appendTo($menu);

      this.mobileMenuActive = true;
    },

    destroyMobileMenu: function ($menu, $container) {
      $container.removeClass(`
        ${this.containerClass}--js ${this.containerClass}--expanded
      `);
      $menu.data('menuButtons').detach();
      $menu.off('.menuButtons');
      this.mobileMenuActive = false;
    }
  };
})(document, Drupal, jQuery);
